import { createEvent } from 'effector';
export function reset(_ref) {
  var {
    clock,
    target
  } = _ref;
  var targets = Array.isArray(target) ? target : [target];
  var clocks = Array.isArray(clock) ? clock : [clock !== null && clock !== void 0 ? clock : createEvent({
    name: "clocks",
    sid: "bqmea5"
  })];
  targets.forEach(target => {
    target.reset(clocks);
  });
  return clock === undefined ? clocks[0] : undefined;
}